/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-empty-function */
import { wireOfflineServiceWorker } from "./registerServiceWorker";

import { createApp } from "vue";
import { createHead } from "@vueuse/head";

import App from "./App.vue";
import router from "./router";

// Loading all components
import globalComponent from "./components";
import layoutComponent from "./layouts";

// Libraries
import numeral from "numeral";

/**
 * Importing external libraries allow to compile them in our bundle
 * How files are interpreted is defined by ther extension.
 */

// Main Style
import "./assets/scss/main.scss";

// Driver.js
import "driver.js/dist/driver.min.css";

import "nprogress/nprogress.css";
import PrimeVue from "primevue/config";

// Primevue style
import "primeflex/primeflex.css";
import "./assets/css/ds-primevue.css";
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css";

// PrimeVue Components — uniquement Skeleton est utilisé en réel (cf.
// src/components/squeletons/*). Les autres (Column, ColumnGroup,
// DataTable, ContextMenu, Calendar, AutoComplete) étaient importés
// eagerly mais audit grep = 0 utilisation → ~60 KB compressé inutiles
// dans le main bundle. Les ré-importer localement le jour où on en a
// besoin.
import Skeleton from "primevue/skeleton";

// Notification style
import "notyf/notyf.min.css";

// API
import * as api from "./api";

// Services
import * as services from "./services";

import { createPinia } from 'pinia'
import { VueQueryPlugin } from "@tanstack/vue-query";
import { queryClient } from "@/composable/queries/queryClient";

// Change POST content type
services.axios.defaults.headers.post["Content-Type"] = "application/json, text/plain, */*";

const app_env = process.env.VUE_APP_ENV;

if (app_env == "production") {
	console.log = () => {};
	console.warn = () => {};
	console.info = () => {};
	console.error = () => {};
}

// Activate session manager
// services.sessionManager.setTabSession();
// services.sessionManager.setTabSessionListener();

// Connect user if token exist and is valid
services.auth.loginWithToken()

// Activate content protection from being copied or modified
// services.contentProtector();

// Now we can start our vue app
const app = createApp(App);
const head = createHead();
const pinia = createPinia()
app.use(pinia);

// Global error handler — transforme les rejections d'objet brut
// (axios error response, etc.) en messages parlants dans la console.
// Sans ça, l'overlay webpack-dev-server affiche '[object Object]'
// car il fait toString() sur un objet non-Error. Avec ce handler,
// on log explicitement url+status+message pour debug rapide.
const niceify = (err: any): string => {
	if (!err) return "Unknown error (null)";
	if (err instanceof Error) return err.stack || err.message;
	if (typeof err === "string") return err;

	// ProgressEvent ('error' XHR event) : récupère le XHR depuis .target
	if (typeof ProgressEvent !== "undefined" && err instanceof ProgressEvent) {
		const xhr = (err.target as XMLHttpRequest) || null;
		if (xhr) {
			return `[XHR error] ${xhr.responseURL || "?"} status=${xhr.status} readyState=${xhr.readyState}` +
				(xhr.responseText ? `\nBody: ${xhr.responseText.substring(0, 500)}` : " (no body — probably blocked/canceled/network)");
		}
		return `[ProgressEvent] type=${err.type}`;
	}

	// XHR brut (cas pusher-js / axios timeout / SW intercept)
	if (typeof XMLHttpRequest !== "undefined" && err instanceof XMLHttpRequest) {
		return `[XHR ${err.status || "0"}] ${err.responseURL || "?"} readyState=${err.readyState}` +
			(err.responseText ? `\nBody: ${err.responseText.substring(0, 500)}` : " (no body — probably blocked/canceled/network)");
	}

	// Axios error shape : { response: {status, data}, config, message }
	if (err.response) {
		const status = err.response.status;
		const url = err.config?.url || err.request?.responseURL || "?";
		const msg = err.response?.data?.response?.message
			|| err.response?.data?.message
			|| err.message
			|| "(no message)";
		return `[HTTP ${status}] ${url} — ${msg}`;
	}

	// Axios "network error" : pas de .response mais .request (XHR)
	if (err.request) {
		const xhr = err.request as XMLHttpRequest;
		const url = err.config?.url || xhr.responseURL || "?";
		return `[Network error] ${url} — ${err.message || "no response"} (XHR status=${xhr.status || 0}, readyState=${xhr.readyState || 0})` +
			"\nCauses fréquentes : Service Worker en cache, extension navigateur (adblock), CORS bloqué, backend down.";
	}

	try { return JSON.stringify(err); } catch { return String(err); }
};
app.config.errorHandler = (err, instance, info) => {
	const componentName = (instance as any)?.$options?.name
		|| (instance as any)?.type?.name
		|| "<unknown>";
	console.error(`[Vue error] ${componentName} during "${info}" :\n${niceify(err)}`);
};
window.addEventListener("unhandledrejection", (event) => {
	console.error("[Unhandled promise rejection]\n" + niceify(event.reason));
});

globalComponent.register(app);
layoutComponent.register(app);

// Filters
app.config.globalProperties.$filters = {
	moneyFormat(value: number) {
		if (value == 0) {
			return value;
		} else {
			return numeral(value).format("0.0a");
		}
	},
};

app.use(router);
app.use(head);
app.use(PrimeVue);

// Vue Query (server-state) — cohabite avec callApi.ts pendant la
// migration progressive. Le QueryClient est un singleton partagé (cf.
// composable/queries/queryClient) pour que les listeners Reverb puissent
// invalider des queries hors contexte de composant.
app.use(VueQueryPlugin, { queryClient });

// Primevu components
app.component("Skeleton", Skeleton);

app.mixin({
	computed: {
		$api() {
			return {
				...api,
			};
		},
	},
});

app.mount("#app");

// P9 — Branche le Service Worker au feature flag offline.service_worker.
// Le SW lui-même reste inactif tant que l'enterprise ne l'a pas activé
// dans son admin (cf. registerServiceWorker.ts pour la logique opt-in).
wireOfflineServiceWorker();
// hmr-bust 21:25

